import * as React from 'react';

import type { ToastPosition } from '../../types/toast-types';

import { viewportClass, viewportStyle } from './toast-viewport-layout';

type ToastViewportProps = {
  position: ToastPosition;
  children: React.ReactNode;
};

/** Polite live region for one screen position. Mounted even when it holds no toast. */
export const ToastViewport = ({ position, children }: ToastViewportProps) => (
  // Callers must not skip an empty viewport: a live region must exist before its first message.
  // Empty is free: `pointer-events-none` (Toast re-enables it) and `fixed` block no clicks/layout.
  <div
    className={viewportClass[position]}
    style={viewportStyle(position)}
    role="status"
    aria-live="polite"
  >
    {children}
  </div>
);
